var inspectoresAdminService = angular.module('posicionamientosAdmin');

inspectoresAdminService.factory('posicionamientosAdminService', ['$http', '$q', '__env', function posicionamientosAdminService($http, $q, __env) {
        var serviceUrl = __env.apiUrl;
    var inspeccionesUrl = 'inspecciones';
    var inspectoresUrl = 'categorias';
        

        function getInspecciones() {
            return $http.get(serviceUrl + inspeccionesUrl + '/posicionamientos');
        }

        function getPosicionamientosInspeccion(id) {
            return $http.get(serviceUrl + inspeccionesUrl + '/posicionamientos/' + id);
        }

    function guardarPosicionamientos(posicionamientos) {
            return $http({
                method: 'put',
                url: serviceUrl + inspeccionesUrl + '/guardarPosicionamientos/',
                data: posicionamientos
            });
        }

    function post(posicionamiento) {
            //return $http.post(serviceUrl + usuariosUrl + '/registrar/' + idRolUsuario, usuario);
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesUrl + '/registrarPosicionamiento',
                params:
                {
                    'posiciones': JSON.stringify(posicionamiento)
                }

            });
        }

        function obtenerPrimerErrorModelState(response) {
            var errores = [];
            for (var key in response.ModelState) {
                for (var i = 0; i < response.ModelState[key].length; i++) {
                    errores.push(response.ModelState[key][i]);
                }
            }
            return errores[0];
        }

        function eliminarPosicionamientos(posicionamientosEliminar) {
            return $http.post(serviceUrl + inspeccionesUrl + '/eliminarPosicionamientos/' + posicionamientosEliminar, { headers: { 'Content-Type': 'application/json' } }).catch(function (response) {
                alert('Error');
            });
        }



        return {
            getInspecciones: getInspecciones,
            getPosicionamientosInspeccion: getPosicionamientosInspeccion,
            guardarPosicionamientos: guardarPosicionamientos,
            post: post,
            obtenerPrimerErrorModelState: obtenerPrimerErrorModelState,
            eliminarPosicionamientos: eliminarPosicionamientos,
        }

    }]);